import { OwcListItem, OwcLogo, OwcTypography } from '@one/react';
import { UserMenuAvatarComponent } from 'common/components';
import { LanguageSelectorComponent } from 'common/components/language-selector';
import { useSessionUser } from 'common/hooks/use-session-user.hook';
import { useAuthContext } from 'core/auth/auth.context';
import { signOutAndClearDevice } from 'core/auth/sign-out.service';
import { env } from 'core/constants/env.constants';
import { useTranslation } from 'core/i18n';
import { LayoutHeaderComponent, ProductInfoStyled, ProductOptionsStyled } from './app.header.style';

const PRODUCT_NAME = 'POC Operations';
const oneTrustId = env.VITE_ONE_TRUST_ID;

export const AppHeaderComponent: React.FC = () => {
  const { userNameInitials, formattedUserName } = useSessionUser();
  const { auth } = useAuthContext();
  const { t } = useTranslation('common');

  return (
    <LayoutHeaderComponent>
      <ProductInfoStyled>
        <OwcLogo name="navify_light_green" size="mini" />
        <div className="product-name">
          <OwcTypography variant="title6">{PRODUCT_NAME}</OwcTypography>
        </div>
      </ProductInfoStyled>
      <ProductOptionsStyled>
        <UserMenuAvatarComponent
          initials={userNameInitials}
          header={formattedUserName}
          onLogout={() => signOutAndClearDevice(auth)}
        >
          <LanguageSelectorComponent />
          {oneTrustId ? (
            <OwcListItem id="ot-sdk-btn" onClick={() => globalThis.Optanon?.ToggleInfoDisplay()}>
              {t('components.user-avatar-menu.cookie-preferences')}
            </OwcListItem>
          ) : undefined}
        </UserMenuAvatarComponent>
      </ProductOptionsStyled>
    </LayoutHeaderComponent>
  );
};
